<template>
  <div class="page-wrapper" v-if="authUserData">
    <Top :authUserData="authUserData" :config="pageHeading.subSidebar"/>

    <!-- PAGE CONTENT-->
    <div id="content" class="nosidebar">
      <PageHeading :config="pageHeading"/>

      <div class="wrapper" style="padding-top: 15px;">
        <router-view
          @alertBox="showAlertBox"
          @alertBar="showAlertBar"
          @setPageHeader="setPageHeader"
          @editItem="editItem"
          @viewItem="viewItem"
          @confirmDelete="confirmDelete"
          ref="page"
        ></router-view>
      </div>
    </div>

    <Notification />

    <!-- Alert Component -->
    <md-dialog-alert
      :md-active.sync="alertBox.shown"
      :md-title="alertBox.title"
      :md-content="alertBox.content"
    />

  </div>
</template>
<script>
import Top from "./Top"
import Notification from '../../mixins/Notification'

export default {
  name: "System",
  data() {
    return {
      authenticated: false,
      authUserData: null,
      pageHeading: {
        sectionName: null,
        sectionIcon: null,
        type: null,
        primaryButtonAction: null,
        secondaryButtonAction: null,
        modelID: null,
        buttons: [],
        subSidebar: {
          buttons: []
        },
      },
      alertBox: {
        shown: false,
        title: 'Warning',
        content: null,
      },
      alertBar: {
        shown: false,
        type: 'success',
        class: null,
        title: null,
        content: null,
        timer: null,
      },
      pageProcessing: false,
      selectedDeleteItem: null,
    }
  },
  mounted() {
    this.getAuthUserData()
  },
  components: {
    Top,
    Notification
  },
  watch: {
    $route(to, from) {
      this.pageHeading = {
        sectionName: null,
        sectionIcon: null,
        type: null,
        primaryButtonAction: null,
        secondaryButtonAction: null,
        modelID: null,
        buttons: [],
        subSidebar: {
          buttons: []
        },
      }
      this.getAuthUserData()
    }
  },
  computed: {
    showDeleteConfirmDialog: {
      get: function () {
        return this.selectedDeleteItem != null
      },
      set: function (e) { console.log(e) }
    }
  },
  methods: {
    getAuthUserData() {
      this.$http.get(this.WebService.authUser)
      .then(res => {
        this.authUserData = res.data
        this.$root.$data.AuthData = res.data
      })
      .catch((err) => {
        console.log(err)
        this.doLogout()
      })
    },
    setPageHeader(settings) {
      Object.assign(this.pageHeading, settings) // Merge settings
      console.log( this.pageHeading )
    },
    editItem(item) {

      let settings = this.$refs.page.pageSettings

      if (settings.useDefault) {
        this.$router.push({ name: settings.sectionName + '.edit', params: { id: item.id } })
      } else if (typeof this.$refs.page.editItem !== 'undefined') {
        this.$refs.page.editItem()
      }
    },
    viewItem(item) {

      let settings = this.$refs.page.pageSettings

      if (settings.useDefault) {
        this.$router.push({ name: settings.sectionName + '.edit', params: { id: item.id } })
      } else if (typeof this.$refs.page.editItem !== 'undefined') {
        this.$refs.page.editItem()
      }
    },

    deleteItem() {
      let settings = this.$refs.page.pageSettings
      let item = this.selectedDeleteItem
      let id = item.id
      if (id)
        this.$http
          .delete(settings.webService + "/" + id)
          .then(res => {
            console.log(res)
            let list = this.$refs.page.datas
            let index = list.indexOf(item)
            list.splice(index, 1)
            this.selectedDeleteItem = null

            if (typeof this.$refs.page.afterDelete !== 'undefined')
              this.$refs.page.afterDelete()


          })
    },
    confirmDelete(item) {
      this.selectedDeleteItem = item
    },
    cancelDelete() {
      this.selectedDeleteItem = null
    },
    showAlertBox(e) {
      if (e.title)
        this.alertBox.title = e.title

      this.alertBox.content = ''
      this.alertBox.content = e.content
      this.alertBox.shown = true

    },
    showAlertBar(e) {
      if (e.title)
        this.alertBar.title = e.title

      if (e.content) {

        this.alertBar.content = ''
        if (e.content instanceof Array) {

          e.content.forEach((item) => {
            this.alertBar.content += "<div>" + item + "</div>"
          })
        }
        else if (e.content instanceof Object) {

          Object.keys(e.content).forEach((key) => {
            this.alertBar.content += "<div>" + e.content[key] + "</div>"
          })

        }
        else {
          this.alertBar.content = e.content
        }

      }

      if (e.type)
        this.alertBar.type = e.type

      this.alertBar.shown = true

      clearTimeout(this.alertBar.timer)
      this.alertBar.timer = setTimeout(() => {
        this.alertBar.shown = false
      }, 5000)
    }
  }
}
</script>